import axios from 'axios';

export function orderAccident(offerInfo, searchInfo, userInfo, insured, orderId, params, bonusSystemValue = 0, isInsuredSame = null) {
    return axios({
        url: `/api/${process.env.VUE_APP_SERVER_MODE}/insurance/accident/order/create`,
        method: 'post',
        data: {
            params: params,
            orderId: orderId,
            offerId: offerInfo.offerId,
            price: offerInfo.price,
            discountPrice: offerInfo.discountPrice,
            bonusSystemValue: bonusSystemValue,
            fullPrice: offerInfo.fullPrice,
            searchInfo: searchInfo,
            payer: userInfo,
            insured: insured,
            isInsuredSame: isInsuredSame !== null ? isInsuredSame : (insured ? false : true)
        },
    });
}